import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Footer from "./components/Footer";
import Contact from "./pages/Contact";
import LaptopViewer from "./pages/LaptopViewer";
import AppleWatch from "./pages/AppleWatch";
import NintendoSwitch from "./pages/NintendoSwitch";
import MacBook from "./pages/MacBook";
import Sony from "./pages/Sony";
import DroneCamera from "./pages/DroneCamera";
import MsStudio from "./pages/MsStudio";


function App() {
  return (
    <Router>
      <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
           <Route path="/contact" element={<Contact />} />
           <Route path="/laptop-viewer" element={<LaptopViewer />} />
           <Route path="/apple-watches" element={<AppleWatch />} />
           <Route path="/nintendo-switch" element={<NintendoSwitch />} />
           <Route path="/macbook" element={<MacBook />} />
           <Route path="/sony" element={<Sony />} />
           <Route path="/drone" element={<DroneCamera />} />
           <Route path="/ms-studio" element={<MsStudio />} />
           
        </Routes>
      <Footer/>
    </Router>
  );
}

export default App;
